import React from "react";
import PropTypes from "prop-types";
import { UswfInput } from "./UswfInput";
import { UnderlinedInput } from "./UnderlinedInput";
import { IMaskInput } from "react-imask";

const NumericFormatCustom = React.forwardRef(function NumericFormatCustom(
  props,
  ref
) {
  const { onChange, value, ...other } = props;

  return (
    <IMaskInput
      mask={Number}
      radix="."
      scale={0}
      unmask
      inputRef={ref}
      value={value.toString()}
      // DO NOT USE onChange TO HANDLE CHANGES!
      // USE onAccept INSTEAD
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      {...other}
    />
  );
});

NumericFormatCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

// prevent label from being prop drilled
export const CreditScoreInput = ({ label, ...props }) => {
  return (
    <UswfInput
      {...props}
      className="credit-score-input"
      InputProps={{
        inputComponent: NumericFormatCustom,
      }}
    />
  );
};

export const CreditScoreUnderlinedInput = (props) => {
  return (
    <UnderlinedInput
      {...props}
      className="credit-score-underlined-input"
      InputProps={{
        inputComponent: NumericFormatCustom,
      }}
    />
  );
};
